import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { LigneBudgetService } from '@service/syndic/ligne-budget.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { LigneBudgetAddComponent } from '../ligne-budget-add/ligne-budget-add.component';

@Component({
  selector: 'app-ligne-budget-list',
  templateUrl: './ligne-budget-list.component.html',
  styleUrls: ['./ligne-budget-list.component.scss']
})
export class LigneBudgetListComponent implements OnInit {
  @Input() lignesBudget: any[] = [];
  @Input() budgetUuid: string = '';
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private ligneBudgetService: LigneBudgetService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'LIGNE_BUDGET_ADD' || data.action === 'LIGNE_BUDGET_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.budgetUuid) {
      this.ligneBudgetService.getList(this.budgetUuid).subscribe((res: any) => {
        this.lignesBudget = res || [];
      });
    }
  }

  addLigneBudget(): void {
    this.ligneBudgetService.edit = false;
    this.ligneBudgetService.setLigneBudget(null);
    this.ligneBudgetService.budgetUuid = this.budgetUuid;
    this.modal(LigneBudgetAddComponent, 'modal-basic-title', 'lg');
  }

  editLigneBudget(row: any): void {
    this.ligneBudgetService.edit = true;
    this.ligneBudgetService.setLigneBudget(row);
    this.ligneBudgetService.budgetUuid = this.budgetUuid;
    this.modal(LigneBudgetAddComponent, 'modal-basic-title', 'lg');
  }

  deleteLigneBudget(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.ligneBudgetService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
